module.exports = __webpack_public_path__ + "img/qr-lpc-android.d99623e0.png";